import React, { useCallback } from 'react'
import { Modal } from '@musinsa/mwms-ds'
import { useMWPShipperCreateForm } from './hooks/useMWPShipperForm'
import { useMLTShipperCreateForm } from './hooks/useMLTShipperForm'
import MWPShipperFormComponent from './forms/MWPShipperForm'
import MLTShipperFormComponent from './forms/MLTShipperForm'
import MCDShipperFormComponent from './forms/MCDShipperForm'
import { useMCDShipperCreateForm } from './hooks/useMCDShipperForm'

interface Props {
  open: boolean
  onClose: () => void
  onRefresh: () => Promise<void>
}

type ShipperType = 'MWP' | 'MLT' | 'MCD'

function ShipperAddModal({ open, onClose, onRefresh }: Props) {
  const [currentType, setCurrentType] = React.useState<ShipperType>('MWP')

  const mwpShipper = useMWPShipperCreateForm(onRefresh, onClose)
  const mltShipper = useMLTShipperCreateForm(onRefresh, onClose)
  const mcdShipper = useMCDShipperCreateForm(onRefresh, onClose)

  const getCurrentShipper = () => {
    switch (currentType) {
      case 'MWP':
        return mwpShipper
      case 'MLT':
        return mltShipper
      case 'MCD':
        return mcdShipper
      default:
        return mwpShipper
    }
  }

  const currentShipper = getCurrentShipper()

  const handleLogisticsServiceTypeChange = useCallback((value: string) => {
    setCurrentType(value as ShipperType)
  }, [])

  const handleClose = () => {
    /** form 데이터 초기화 */
    getCurrentShipper().form.reset()

    onClose()
  }

  const renderForm = () => {
    switch (currentType) {
      case 'MWP':
        return (
          <MWPShipperFormComponent type="create" form={mwpShipper.form as any} onLogisticsServiceTypeChange={handleLogisticsServiceTypeChange} />
        )
      case 'MLT':
        return (
          <MLTShipperFormComponent type="create" form={mltShipper.form as any} onLogisticsServiceTypeChange={handleLogisticsServiceTypeChange} />
        )
      case 'MCD':
        return (
          <MCDShipperFormComponent type="create" form={mcdShipper.form as any} onLogisticsServiceTypeChange={handleLogisticsServiceTypeChange} />
        )
      default:
        return null
    }
  }

  if (!open) return null

  return (
    <Modal
      open
      size="md"
      title="화주사 추가"
      buttons={[
        { kind: 'secondary', content: '취소', onClick: handleClose },
        { kind: 'primary_light', content: '추가', onClick: currentShipper.handleSubmit, disabled: !currentShipper.isValid },
      ]}
      onClose={handleClose}
    >
      {renderForm()}
    </Modal>
  )
}

export default ShipperAddModal
